import {Reducer} from "redux";
import {IApplicationState} from "../types";

const deleteEntity: Reducer<IApplicationState['map']> = (state, action) => {
    let mapStyle = state?.mapStyle;
    const {fullUid, type} = action.payload;
    const fPath = ['sources', type, 'data', 'features'];
    let features = mapStyle?.getIn(fPath);

    features = features.filter((f: any) => f.getIn(['properties', 'fullUid']) !== fullUid);
    mapStyle = mapStyle?.setIn([...fPath], features);
    return {...state, mapStyle} as IApplicationState['map'];
}

export { deleteEntity };
